export default __webpack_public_path__ + "static/media/marketplace_login_bg.ea9c0e14.jpg";